<template lang="pug">
div
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width="600px" persistent)
    v-card
      v-card-title.pa-4
        div
          div.s1.primary--text {{ $t('lead_details') }}
          div.c1.basic600--text {{ $t('control_what_you_see') }} 
      v-card-text.pa-0
        v-row.px-4(no-gutters)
          v-col.py-2(cols="6")
            y-checkbox(v-model="dummy.name" :color="$vuetify.theme.themes[$theme].info500" disabled)
              template(v-slot:label)
                div.p2.my-auto {{ $t('lead_name') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="dummy.amount" :color="$vuetify.theme.themes[$theme].info500" disabled)
              template(v-slot:label)
                div.p2.my-auto {{ $t('potential_amount') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="dummy.number" :color="$vuetify.theme.themes[$theme].info500" disabled)
              template(v-slot:label)
                div.p2.my-auto {{ $t('invoice_number') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="dummy.item" :color="$vuetify.theme.themes[$theme].info500" disabled)
              template(v-slot:label)
                div.p2.my-auto {{ $t('number_of_items') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.customerPhone" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('phone_number') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.customerEmail" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('email_address') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.address" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('address') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.itemsOrdered" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('items_ordered') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.orderMessage" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('customers_note') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.shippingMethod" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('fulfilment_method') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.extraInfo" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('extra_info') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.source" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('source') }}
          v-col.py-2(cols="6")
            y-checkbox(v-model="followUpDetails.scheduledDateTime" :color="$vuetify.theme.themes[$theme].info500")
              template(v-slot:label)
                div.p2.my-auto {{ $t('scheduled_date_time') }}
        .preview
          div.px-4.label.basic600--text {{ $t('preview') }}
          v-card.mx-2.mb-2.mt-4.py-2
            div.d-flex.align-center.px-4.py-2
              div
                div.h6.basic800--text RM 2,480
                div.c1.danger500--text(style="margin-top: 2px") 1 hour ago
              v-spacer
              v-btn.button-AA-small(color="info500" small height="32" dark)
                v-icon(small left) mdi-whatsapp
                | contact
            v-divider.basic300.mx-4
            div.px-4.mt-2
              div.p2.primary--text Muhammad Danial Hakim
              div.d-flex.align-center
                div.p2.basic600--text 4 items
                v-spacer
                div.c1.basic600--text #229


            div.px-4.mt-2

              div.d-flex.align-center(v-if="followUpDetails.source || followUpDetails.customerPhone")
                //- PHONE NUMBER
                template(v-if="followUpDetails.customerPhone")
                  div.p2.basic700--text.mb-1 +6 012345 6789
                  v-spacer
                //- SOURCE
                div.c1.basic600--text.mb-1(v-if="followUpDetails.source") Yezza Store

              //- EMAIL
              template(v-if="followUpDetails.customerEmail")
                div.p2.basic700--text.mb-1 customer@gmail.com

              .customer-selection(v-if="followUpDetails.shippingMethod || followUpDetails.scheduledDateTime || followUpDetails.address")
                div.c1.basic600--text.mb-1 {{ $t('customer_selection') }}:

                //- FULFILMENT
                div.d-flex.align-center.mb-1(v-if="followUpDetails.shippingMethod")
                  eva-icon.mb-n1.mr-1(name="car-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  div.p2.basic700--text Lalamove

                //- DATE TIME
                div.d-flex.align-center.mb-1(v-if="followUpDetails.scheduledDateTime")
                  eva-icon.mb-n1.mr-1(name="clock-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  div.p2.basic700--text Fri, 01/01/21 at 12:00PM

                //- ADDRESS
                v-row.mb-1(no-gutters v-if="followUpDetails.address")
                  v-col.shrink.pr-1
                    eva-icon.mb-n1(name="pin-outline" :fill="$vuetify.theme.themes[$theme].basic700" width="15" height="15")
                  v-col.pr-6(cols="10")
                    div.p2.basic700--text 60000 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur

              //- ITEMS ORDERED
              template(v-if="followUpDetails.itemsOrdered")
                v-divider.basic300.mb-2
                div.d-flex.mb-1
                  div.c1.primary500--text 1x
                  div.ml-3
                    div.c2.primary500--text Product A
                div.d-flex.mb-2
                  div.c1.primary500--text 1x
                  div.ml-3
                    div.c2.primary500--text Product B
                    
              //- CUSTOMER'S NOTE
              template(v-if="followUpDetails.orderMessage")
                v-divider.basic300.mb-2
                div.c1.basic600--text.mb-2 Message: No cutleries

              //- EXTRA INFO
              template(v-if="followUpDetails.extraInfo")
                v-divider.basic300.mb-2
                div.c1.primary--text.mb-1 Extra info 1: Text
                div.c1.primary--text.mb-1 Extra info 2: Text

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='resetDefault')
          .button-Aa-small.primary400--text {{ $t('reset_to_default') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click="saveFollowUpDetails" dark)
          .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FollowUpDetailsFilter',
  props: ['open', 'field'],
  data: () => ({
    followUpDetails: {},
    dummy: {
      name: true,
      amount: true,
      number: true,
      item: true
    }
  }),
  computed: {
    ...mapGetters({
      details: 'followup/getFollowUpDetails'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
  },
  mounted () {
    this.followUpDetails = { ...this.details }
  },
  methods: {
    saveFollowUpDetails () {
      this.$store.commit('followup/setFollowUpDetails', this.followUpDetails)
      this.showModal = false
    },
    resetDefault () {
      this.followUpDetails = {
        customerPhone: false,
        customerEmail: false,
        address: false,
        itemsOrdered: false,
        orderMessage: false,
        shippingMethod: false,
        extraInfo: false,
        source: false,
        scheduledDateTime: false
      }
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "lead_details": "Lead details",
    "control_what_you_see": "Control what you see when viewing your follow up list",
    "lead_name": "Lead name",
    "potential_amount": "Potential amount",
    "invoice_number": "Invoice number",
    "number_of_items": "Number of items",
    "phone_number": "Phone number",
    "email_address": "Email address",
    "address": "Address",
    "items_ordered": "Items ordered",
    "customers_note": "Customer’s note",
    "fulfilment_method": "Fulfilment method",
    "extra_info": "Extra info",
    "preview": "PREVIEW"
  },
  "id": {
    "lead_details": "Detail leads",
    "control_what_you_see": "Kontrol apa yang kamu lihat saat melihat daftar follow-up",
    "lead_name": "Nama lead",
    "potential_amount": "Jumlah potensi",
    "invoice_number": "Nomor faktur",
    "number_of_items": "Jumlah Item",
    "phone_number": "Nomor telepon",
    "email_address": "Alamat email",
    "address": "Alamat",
    "items_ordered": "Item yang dipesan",
    "customers_note": "Catatan Pelanggan",
    "fulfilment_method": "Metode Penyelesaian",
    "extra_info": "Informasi Tambahan",
    "preview": "PRATINJAU"
  }
}
</i18n>
